// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
/**
 * Version of the auditable ballots whose tracker does not cover the ballot
 * style they carry.
 */
export var LEGACY_BALLOT_VERSION = 2;
/**
 * The outcome of comparing the ballot style carried by an auditable ballot
 * with the ballot styles published for the election.
 */
export var EBallotStyleCheck;
(function (EBallotStyleCheck) {
    EBallotStyleCheck["MATCHES"] = "MATCHES";
    EBallotStyleCheck["MISMATCH"] = "MISMATCH";
    EBallotStyleCheck["NOT_PUBLISHED"] = "NOT_PUBLISHED";
})(EBallotStyleCheck || (EBallotStyleCheck = {}));
var layoutOf = function (ballotStyle) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return JSON.stringify({
        election_id: ballotStyle.election_id,
        area_id: ballotStyle.area_id,
        public_key: (_b = (_a = ballotStyle.public_key) === null || _a === void 0 ? void 0 : _a.public_key) !== null && _b !== void 0 ? _b : null,
        is_demo: (_d = (_c = ballotStyle.public_key) === null || _c === void 0 ? void 0 : _c.is_demo) !== null && _d !== void 0 ? _d : null,
        configuration_id: (_f = (_e = ballotStyle.public_key) === null || _e === void 0 ? void 0 : _e.configuration_id) !== null && _f !== void 0 ? _f : null,
        // Recovery can remap the ceremony UUID while preserving Configuration.id.
        // The UUID defines the native domain only without that immutable ID.
        keys_ceremony_id: ((_g = ballotStyle.public_key) === null || _g === void 0 ? void 0 : _g.configuration_id) == null
            ? ((_j = (_h = ballotStyle.public_key) === null || _h === void 0 ? void 0 : _h.keys_ceremony_id) !== null && _j !== void 0 ? _j : null)
            : null,
        contests: ballotStyle.contests.map(function (contest) { return ({
            id: contest.id,
            candidates: contest.candidates.map(function (candidate) { return candidate.id; }),
        }); }),
    });
};
/**
 * Compares the election, area, native key/domain and the order of contests and
 * candidates of the ballot style carried by an auditable ballot with the
 * published ballot style that has the same id. Only MATCHES lets the ballot
 * through, so the caller fails closed on the other two outcomes.
 */
export var checkAuditedBallotStyle = function (auditedStyle, publishedStyles) {
    var sameId = publishedStyles.filter(function (published) { return published.id === auditedStyle.id; });
    if (0 === sameId.length) {
        return EBallotStyleCheck.NOT_PUBLISHED;
    }
    var auditedLayout = layoutOf(auditedStyle);
    return sameId.some(function (published) { return layoutOf(published) === auditedLayout; })
        ? EBallotStyleCheck.MATCHES
        : EBallotStyleCheck.MISMATCH;
};
/**
 * The ballot styles of the published ballot publications, read from the
 * ballot_eml of each row. A row that cannot be read is left out, so the ballot
 * style it carried cannot be matched.
 */
export var parsePublishedBallotStyles = function (data) {
    if (!data) {
        return [];
    }
    var publishedIds = new Set(data.sequent_backend_ballot_publication.map(function (publication) { return publication.id; }));
    var styles = [];
    for (var _i = 0, _a = data.sequent_backend_ballot_style; _i < _a.length; _i++) {
        var row = _a[_i];
        if (!publishedIds.has(row.ballot_publication_id) || "string" !== typeof row.ballot_eml) {
            continue;
        }
        try {
            styles.push(JSON.parse(row.ballot_eml));
        }
        catch (error) {
            console.log("Error loading EML: ".concat(error));
        }
    }
    return styles;
};
